import React from "react";
import "./footer.scss";

const Footer = () => {
  return (
    <div className="footer py-3">
      <h2 className="text-center fs-6">
        © All Right Reserved by Ruhul Amin Sujon
      </h2>
    </div>
  );
};

export default Footer;
